import React, { useState, useEffect } from 'react';
import { Tabs, Loading, Empty, Picker, Popup } from 'react-vant';
import { ArrowLeft, ArrowDown, CalendarO, MedalO } from '@react-vant/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../api/request';

const SportsReports = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [standings, setStandings] = useState([]);
  const [resultsBook, setResultsBook] = useState([]);
  const [meets, setMeets] = useState([]);
  const [currentMeet, setCurrentMeet] = useState(null);
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    fetchMeets();
  }, []);

  const fetchMeets = async () => {
    try {
      const [activeRes, archivedRes] = await Promise.allSettled([
        request.get('/v2/sports/meets/', { params: { is_archived: false, page_size: 50 } }),
        request.get('/v2/sports/meets/', { params: { is_archived: true, page_size: 50 } })
      ]);
      const activeList = activeRes.status === 'fulfilled' ? (activeRes.value?.items || []) : [];
      const archivedList = archivedRes.status === 'fulfilled' ? (archivedRes.value?.items || []) : [];
      
      const allMeets = [
        ...activeList,
        ...archivedList.filter(a => !activeList.some(act => act.id === a.id))
      ];

      setMeets(allMeets.map(m => ({
        text: m.is_archived ? `${m.name} (往届)` : m.name,
        value: m.id
      })));

      if (allMeets.length > 0) {
        const defaultMeet = allMeets.find(m => !m.is_archived) || allMeets[0];
        setCurrentMeet(defaultMeet);
        fetchData(defaultMeet.id, activeTab === 0 ? 'standings' : 'results');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async (meetId, type) => {
    setLoading(true);
    try {
      if (type === 'standings') {
        const res = await request.get('/v2/sports/reports/standings/', {
          params: { sports_meet_id: meetId }
        });
        setStandings(res.rankings || []);
      } else {
        const res = await request.get('/v2/sports/reports/results-book/', {
          params: { sports_meet_id: meetId }
        });
        setResultsBook(res.grades || []);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (index) => {
    setActiveTab(index);
    if (currentMeet) {
      fetchData(currentMeet.id, index === 0 ? 'standings' : 'results');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--canvas-bg, #f8fafc)', paddingBottom: 60 }}>
      {/* 沉浸式星瀚空天蓝页眉 */}
      <div style={{
        background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
        padding: '44px 16px 20px',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* 装饰半透圆 */}
        <div style={{
          position: 'absolute', top: -30, right: -30,
          width: 140, height: 140, borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.08)'
        }} />

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
          <div
            onClick={() => navigate(-1)}
            style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            <ArrowLeft color="#fff" fontSize={18} />
          </div>

          <div style={{ textAlign: 'center' }}>
            <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#fff', letterSpacing: '-0.2px' }}>
              报表中心
            </h1>
            <p style={{ margin: '2px 0 0', fontSize: 11.5, color: 'rgba(255,255,255,0.85)', fontWeight: 400 }}>
              团体总分榜与官方项目成绩册
            </p>
          </div>

          <div
            onClick={() => setShowPicker(true)}
            style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer'
            }}
            title="选择运动会"
          >
            <CalendarO color="#fff" fontSize={18} />
          </div>
        </div>
      </div>

      {/* 运动会快速切换栏 */}
      <div 
        onClick={() => setShowPicker(true)}
        style={{
          padding: '10px 16px',
          background: '#ffffff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e2e8f0',
          cursor: 'pointer'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0 }}>
          <span style={{ fontSize: 15 }}>🏆</span>
          <span style={{ fontSize: 13, color: '#056b4f', fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {currentMeet?.name || '选择运动会'}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#64748b', fontSize: 12 }}>
          <span>切换</span>
          <ArrowDown style={{ fontSize: 11 }} />
        </div>
      </div>

      {/* 选项卡 */}
      <div style={{ background: '#ffffff', borderBottom: '1px solid #e2e8f0' }}>
        <Tabs
          active={activeTab}
          onChange={handleTabChange}
          color="#056b4f"
          titleActiveColor="#056b4f"
          border={false}
          lineHeight={3}
          lineWidth={28}
        >
          <Tabs.TabPane title="🏆 团体积分榜" />
          <Tabs.TabPane title="📜 项目成绩册" />
        </Tabs>
      </div>

      <div style={{ padding: '14px 16px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}>
            <Loading type="spinner" color="#056b4f" vertical>生成报表中...</Loading>
          </div>
        ) : activeTab === 0 ? (
          // 团体积分榜 View
          standings.length === 0 ? (
            <div style={{ padding: '60px 0' }}>
              <Empty description="暂无积分榜数据" />
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {standings.map((item, idx) => {
                const isTop3 = idx < 3;
                return (
                  <div key={idx} style={{ 
                    background: '#ffffff',
                    borderRadius: 16,
                    padding: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                    border: '1px solid #f1f5f9'
                  }}>
                    {/* 排名徽章 */}
                    <div style={{ 
                      width: 36, height: 36, borderRadius: '50%', 
                      background: idx === 0 
                        ? 'linear-gradient(135deg, #fa8c16 0%, #d97706 100%)' 
                        : (idx === 1 
                          ? 'linear-gradient(135deg, #94a3b8 0%, #64748b 100%)' 
                          : (idx === 2 
                            ? 'linear-gradient(135deg, #ea580c 0%, #c2410c 100%)' 
                            : '#f1f5f9')),
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: isTop3 ? '#ffffff' : '#64748b',
                      fontWeight: 800, fontSize: 14,
                      boxShadow: isTop3 ? '0 4px 10px rgba(0,0,0,0.15)' : 'none',
                      flexShrink: 0
                    }}>
                      {item.rank}
                    </div>

                    <div style={{ flex: 1, marginLeft: 14, minWidth: 0 }}>
                      <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 3 }}>
                        {item.class_name}
                      </div>
                      <div style={{ fontSize: 12, color: '#64748b' }}>
                        {item.grade}
                      </div>
                    </div>

                    <div style={{ textAlign: 'right' }}>
                      {/* 奖牌统计 */}
                      <div style={{ display: 'flex', gap: 4, justifyContent: 'flex-end', marginBottom: 4 }}>
                        <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 4, background: '#fffbeb', color: '#b45309', fontWeight: 700 }}>
                          🥇{item.gold || 0}
                        </span>
                        <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 4, background: '#f8fafc', color: '#475569', fontWeight: 700, border: '1px solid #e2e8f0' }}>
                          🥈{item.silver || 0}
                        </span>
                        <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 4, background: '#fff7ed', color: '#c2410c', fontWeight: 700 }}>
                          🥉{item.bronze || 0}
                        </span>
                      </div>
                      <div style={{ fontSize: 19, fontWeight: 800, color: '#056b4f' }}>
                        {item.total_points || 0}<span style={{ fontSize: 12, marginLeft: 2, fontWeight: 500 }}>分</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )
        ) : (
          // 项目成绩册 View
          resultsBook.length === 0 ? (
            <div style={{ padding: '60px 0' }}>
              <Empty description="暂无成绩册数据" />
            </div>
          ) : (
            resultsBook.map((gradeGroup, gIdx) => (
              <div key={gIdx} style={{ marginBottom: 20 }}>
                {/* 年级标题 */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10, padding: '0 4px' }}>
                  <div style={{ width: 4, height: 16, background: '#056b4f', borderRadius: 2 }} />
                  <span style={{ fontSize: 16, fontWeight: 800, color: '#0f172a' }}>{gradeGroup.grade}</span>
                </div>
                
                {gradeGroup.events.map((event, eIdx) => (
                  <div key={eIdx} style={{
                    background: '#ffffff',
                    borderRadius: 16,
                    padding: '16px',
                    marginBottom: 12,
                    boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                    border: '1px solid #f1f5f9'
                  }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: '#056b4f', marginBottom: 10 }}>
                      🏃 {event.event_name}
                    </div>
                    
                    <div style={{
                      background: '#f8fafc',
                      borderRadius: 8,
                      padding: '8px 12px',
                      display: 'flex',
                      marginBottom: 6,
                      fontSize: 12,
                      color: '#64748b',
                      fontWeight: 600
                    }}>
                      <span style={{ width: 40 }}>名次</span>
                      <span style={{ flex: 1 }}>姓名</span>
                      <span style={{ width: 90 }}>班级</span>
                      <span style={{ width: 64, textAlign: 'right' }}>成绩</span>
                    </div>

                    {event.results?.map((res, rIdx) => (
                      <div key={rIdx} style={{ 
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px 12px',
                        borderTop: '1px solid #f8fafc'
                      }}>
                        <span style={{
                          width: 40,
                          fontSize: 13,
                          color: res.rank <= 3 ? '#ff5e1e' : '#64748b',
                          fontWeight: 700
                        }}>
                          {res.rank <= 3 ? (res.rank === 1 ? '🥇 1' : res.rank === 2 ? '🥈 2' : '🥉 3') : res.rank}
                        </span>
                        <span style={{ flex: 1, fontSize: 14, fontWeight: 600, color: '#0f172a' }}>
                          {res.student_name}
                        </span>
                        <span style={{ width: 90, fontSize: 12, color: '#64748b' }}>
                          {res.class_name}
                        </span>
                        <div style={{
                          width: 64,
                          fontSize: 14,
                          color: '#056b4f',
                          fontWeight: 700,
                          textAlign: 'right',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-end'
                        }}>
                          {res.performance}
                          {res.is_record && <span style={{ color: '#e11d48', fontSize: 11, marginLeft: 2 }} title="破纪录">⚡</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))
          )
        )}
      </div>

      <Popup visible={showPicker} round position="bottom">
        <Picker
          title="选择运动会"
          columns={meets}
          onConfirm={(v, o) => {
            setCurrentMeet({ id: o.value, name: o.text });
            setShowPicker(false);
            fetchData(o.value, activeTab === 0 ? 'standings' : 'results');
          }}
          onCancel={() => setShowPicker(false)}
        />
      </Popup>
    </div>
  );
};

export default SportsReports;
